<template>
  <div
    :class="{
      'wap-footer': true,
      'wap-footer-border': hasBorder,
    }"
  >
    <!--兼容白牌计算高度-->
    <div
      v-if="spver"
      style="width: 1px; height: 1px"
    />
    <footer
      v-else-if="!spver && loadingFinished"
      class="dt-footer"
    >
      <a href="http://m.sogou.com">首页</a>-<a
        href="http://wap.sogou.com/web/terms.jsp"
      >免责</a>-<a href="https://fankui.sogou.com/wap/fb.php?fr=video">用户反馈</a>
      <p>© {{ year }} SOGOU.COM</p>
    </footer>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { getSpver } from '../js/util';

export default {
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
  computed: {
    ...mapState('common', ['loadingFinished']),
    spver() {
      return getSpver({ spver: this.$route.query.spver, returnType: 'boolean' }) || false;
    },
    hasBorder() {
      return ['home'].indexOf(this.$route.name) > -1;
    },
  },
};
</script>

<style lang="scss">
@import '../../../asset/css/abstracts/mixin.scss';

.loading-result {
  position: relative;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
.loading-result:before {
  content: '';
  display: inline-block;
  width: 20px;
  height: 20px;
  background: url(../../../asset/img/loading.gif) no-repeat center;
  background-size: 20px 20px;
  vertical-align: middle;
}
.wap-footer {
  &.wap-footer-border {
    border-top: 8px solid #f5f5f5;
  }
  .dt-footer {
    padding: 24px 0 39px;
    text-align: center;
    > a {
      margin: 0 6px;
      font-size: 14px;
      color: #000;
      line-height: 21px;
    }
    > p {
      margin-top: 11px;
      color: #999;
      font-size: 12px;
    }
  }
}
</style>
